import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./HomePage.css";
import socketClient from "../socket/socketClient";
import introduceOneImage from "../images/1.png";
import introduceTwoImage from "../images/2.png";
import introduceThreeImage from "../images/3.png";
import introduceFourImage from "../images/4.png";
import introduceFiveImage from "../images/5.png";
import introduceSevenImage from "../images/7.png";
import introduceEightImage from "../images/8.png";
import introduceNineImage from "../images/9.png";
import introduceTenImage from "../images/10.png";
import introduceElevenImage from "../images/11.png";
import FilterPanel from "./components/FilterPanel"; // 导入自定义组件
import Button from "react-bootstrap/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSyncAlt, faArrowUp } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
const stypeObj = {
  passed: "green-passed",
  approve: "yellow",
  detail: "blue",
  ignore: "red",
  reject: "red",
};

const TEXTS = {
  closeOnlineResume: "请关闭在线简历",
  closeAttachment: "关闭附件简历",
  downloadAttachment: "下载附件简历",
  pleaseReply: "请回复文本",
  waitReply: "等待生成回复...",
  copiedToClipboard: "已为你复制到剪切板，直接粘贴发送即可",
  nextCandidate: "完成后，请点击下一个未读候选人",
  clickCandidate: "请点击一个未读候选人",
  noQuota: "当前职位没有打招呼配额了",
  switchToPositionManagement: "请先切换到『职位管理』栏目",
  getQuota: "请点击『招聘数据』获取打招呼配额",
  switchToRecommend: "请切换到『推荐牛人』或者【沟通】栏目",
  setBossRecommend: "请参照以下选中条件 设置boss推荐牛人筛选项",
  changePositionName: "请更换职位名",
  noReplyToNextCandidate: "无需回复，直接下一个未读候选人",
  clickOnlineResumeAndScroll: "请点击在线简历，并向下滚动简历",
  clickOnlineResume: `点击“求简历"按钮`,
  clickWechat: `点击“换微信"按钮`,
  clickPhone: `点击“换电话"按钮`,
  socketError: `socket连接异常`,
  clickAgreeExchangeWechat: `点击“同意"交换微信`,
  clickAgreeExchangePhone: `点击“同意"交换手机号`,
  clickAgreeAcceptResume: `点击“同意"接收简历`,
};

const LAMP_STYLES = {
  marginTop: "10px",
};
interface UserType {
  type: keyof typeof stypeObj;
  name: string;
  uuid: string;
}

interface LampComponentProps {
  lampClass: string;
  text: string;
  children?: React.ReactNode;
}

interface UserBossComponentProps {
  userName: string;
  bossName: string;
}

interface BossInfoComponentProps {
  action: string;
  // platform: string;
  customer: { uid: string };
  bot: { uid: string };
  content: string;
  title: string;
  // dialogList: Array<any>;
}

const LampComponent = ({ lampClass, text, children }: LampComponentProps) => (
  <div className="lamp-image">
    <div className="color-lamp">
      <div className={`lamp ${lampClass}`}></div>
      <span>{text}</span>
    </div>
    {children}
  </div>
);

const UserBossComponent = ({ userName, bossName }: UserBossComponentProps) => (
  <div className="user-boss">
    <div className="username">{userName}</div>
    <div className="bossname">{bossName}</div>
  </div>
);

const UpdateDialogButton = ({
  bot,
  customer,
  content,
  action,
  title,
}: BossInfoComponentProps) => {
  const handleClick = () => {
    const platform = "boss";
    let dialogList: {
      flow: number;
      type: string;
      content: string;
      status: number;
    }[] = [];

    let message_list: {
      type: string;
      content: string;
    }[] = [];

    if (action === "update_dialog") {
      if (title === "我已同意接收简历") {
        dialogList = [
          {
            flow: 1,
            type: "accept_resume",
            content: content,
            status: 3,
          },
        ];
      } else {
        dialogList = [
          {
            flow: 1,
            type: "text",
            content: content,
            status: 3,
          },
        ];
      }
    } else if (action === "request_resume") {
      message_list = [
        {
          type: action,
          content: "请求简历",
        },
      ];
    } else if (action === "request_wechat") {
      message_list = [
        {
          type: action,
          content: "请求微信",
        },
      ];
    } else if (action === "request_phone") {
      message_list = [
        {
          type: action,
          content: "请求电话",
        },
      ];
    }
    console.log(
      "handleClick 我已发",
      customer,
      bot,
      action,
      platform,
      dialogList,
      message_list
    );

    socketClient.sendMessage({
      customer: { uid: customer.uid },
      bot: { uid: bot.uid },
      action,
      platform,
      dialogList,
      special: 1,
      message_list,
      isFromBoss: 0,
    });
  };
  return (
    <Button size="sm" onClick={handleClick}>
      {title}
    </Button>
  );
};

function HomePage() {
  let navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const roomNumber = queryParams.get("room") || "";
  const name = queryParams.get("name") || "看板";
  // console.log("home queryParams", name, roomNumber);
  const [userName, setUserName] = useState("");
  const [bossName, setBossName] = useState("");
  const [replyContent, setReplyContent] = useState("");
  const [replyList, setReplyList] = useState<Array<any>>([]);
  const [currentPositionName, setCurrentPositionName] = useState("");
  const [nextPositionName, setNextPositionName] = useState("");
  const [stateTag, setStateTag] = useState(0);
  const [chatList, setChatList] = useState<Record<string, any>[]>([]);
  const [condition, setCondition] = useState<Record<string, any>>({});
  const [bossDataSource, setBossDataSource] = useState<boolean>(true);
  const [lastMsgForBoss, setLastMsgForBoss] = useState<Record<string, any>>();
  const [copySendOk, setCopySendOk] = useState(false);
  const [recommendList, setRecommendList] = useState<UserType[]>([]);
  const [botInfo, setBotInfo] = useState<Record<string, any>>({});
  const [switchPast, setSwitchPast] = useState(true);
  const [mode, setMode] = useState("L2");

  let autoGreetType = localStorage.getItem("autoGreetType") || "";
  let autoChatType = localStorage.getItem("autoChatType") || "";

  const [switchAuto, setSwitchAuto] = useState(
    autoGreetType === "mx_board_auto_greet_open"
  ); // 默认开启

  const [switchAutoChat, setSwitchAutoChat] = useState(
    autoChatType === "mx_board_auto_chat_open"
  ); // 默认开启

  const [customerInfo, setcustomerInfo] = useState<Record<string, any>>({});
  useEffect(() => {
    if (!socketClient.socketio) {
      socketClient.connect(
        {
          url: `localhost:3000?name=${name}&room=${roomNumber}`,
          // url: `192.168.0.99:3000?name=${name}&room=${roomNumber}`,
          room: roomNumber,
          name,
        },
        () => {},
        () => {
          console.log("socket connected");
          socketClient.initListenMessage();
        }
      );
    }

    socketClient.addListener("home", {
      receiveSendMessage,
      updateDialog,
      requestOnlineResume,
      acceptAttachResume,
      routeJoblist,
      routeRecommend,
      changeRecommendPosition,
      checkFilterPanel,
      addRecommendList,
      routeToDataRecruit,
      noticeNoQuota,
      updateCandidateUser,
      autoGreetAction,
      autoChatAction,
      autoGreetLevelAction,
      connectTimeOut,
      connectError,
    });
    // 返回一个清理函数
    return () => {
      socketClient.removeListener("home");
    };
  });

  function connectTimeOut() {
    console.log("connectTimeOut");
  }

  function connectError() {
    console.log("home connectError");
    setStateTag(-1);
  }

  function updateDialog(msg: any) {
    console.log("home updateDialog", msg);
    replySwitchPast(msg);
    autoGreetAction(msg.autoGreetType || "");
    autoChatAction(msg.autoChatType || "");
    autoGreetLevelAction(msg.autoGreetLevel || "");
    if (msg.special) {
      return;
    }
    var list: Record<string, any>[] = [];
    // 消息流向 1:从机器人到客户, 2:从客户到机器人
    msg.dialogList &&
      msg.dialogList.forEach(
        (info: { type: string; flow: number; content: any }) => {
          var txt = "";
          // if (info.flow === 1) {
          // txt = `${msg.bot.name}: ${info.content}`;
          //   txt = `${info.content}`;
          // } else if (info.flow === 2) {
          if (info.type === "image") {
            // txt = `${msg.customer.name}: ${
            //   info.content && info.content.text
            //     ? info.content.text
            //     : info.content
            // }`;
            txt = `${
              info.content && info.content.text
                ? info.content.text
                : info.content
            }`;
          } else {
            // txt = `${msg.customer.name}: ${info.content}`;
            txt = `${info.content}`;
          }
          // } else if (info.flow === 3) {
          // txt = `系统消息: ${info.content}`;
          //   txt = `${info.content}`;
          // }
          list.push({ ...info, txt, bot: msg.bot, customer: msg.customer });
        }
      );
    setChatList(list);
    if (msg.customer) {
      setUserName(msg.customer.name);
      setcustomerInfo(msg.customer);
    }
    if (msg.bot) {
      setBossName(msg.bot.name);
      setBotInfo(msg.bot);
    }

    let lastMsg = getLastSentMessage(list);
    if (lastMsg) {
      if (lastMsgForBoss && lastMsg.content === lastMsgForBoss.content) {
        setCopySendOk(true);
      } else {
        setCopySendOk(false);
      }
    }
    setStateTag(1);
  }

  function getLastSentMessage(chatList: string | any[]) {
    for (let i = chatList.length - 1; i >= 0; i--) {
      if (chatList[i].flow === 1 || i === chatList.length - 1) {
        return chatList[i];
      }
    }
    return null; // 如果没有找到任何流等于1的消息，则返回null
  }

  function requestOnlineResume(msgs: any) {
    console.log("home requestOnlineResume", msgs);
    setStateTag(2);
  }

  // 需要回复的消息
  function receiveSendMessage(data: any) {
    console.log("home receiveSendMessage", data);
    if (data.special) {
      return;
    }
    if (data.customer && data.customer.name !== userName) {
      console.log(
        "home receiveSendMessage 不是同一个人收到的消息 忽略",
        userName
      );
      return;
    }
    if (data.message_list) {
      let nop = data.message_list.find((item: any) => item.type === "nop");
      if (nop) {
        setStateTag(6);
      } else {
        setStateTag(3);
        setReplyList(data.message_list);
      }
      // data.message_list.forEach((message: any) => {
      //   if (message.type === "nop") {
      //     setStateTag(6);
      //   } else {
      //     setStateTag(3);
      //     let lastMsg = getLastSentMessage(message);
      //     lastMsg && setLastMsgForBoss(lastMsg);
      //     console.log("home receiveSendMessage setLastMsgForBoss", lastMsg);
      //   }
      //   console.log("home receiveSendMessage message", message);
      //   message.content && setReplyContent(message.content);
      // });
    }
  }

  function acceptAttachResume(data: any) {
    console.log("home acceptAttachResume", data);

    if (data.message_list) {
      data.message_list.forEach((message: any) => {
        console.log("home acceptAttachResume message", message);
        setReplyContent(message.content ? message.content : "");
      });
      setStateTag(4);
    } else {
      setReplyContent("");
      console.log("home acceptAttachResume chatList", chatList);
      let item = chatList.find((item) => item.type === "resume");
      if (item) {
        setStateTag(5);
      } else {
        setStateTag(4);
      }
    }
  }

  function routeJoblist(data: any) {
    console.log("home routeJoblist", data);
    if (data.customer) {
      setStateTag(7);
      data.bot && setBossName(data.bot.name);
    } else {
    }
  }

  function routeToDataRecruit(data: any) {
    console.log("home routeToDataRecruit 需要去获取配额", data);
    if (data.customer) {
      setStateTag(12);
      data.bot && setBossName(data.bot.name);
    } else {
    }
  }

  function noticeNoQuota(data: any) {
    console.log("home noticeNoQuota 当前职位没有配额了", data);
    if (data.customer) {
      setStateTag(13);
      data.bot && setBossName(data.bot.name);
      setCurrentPositionName(data.currentPosition || "");
    } else {
    }
  }

  function routeRecommend(data: any) {
    console.log("home routeRecommend", data);
    if (data.customer) {
      setStateTag(8);
      data.bot && setBossName(data.bot.name);
    } else {
    }
  }

  function changeRecommendPosition(data: any) {
    console.log("home changeRecommendPosition", data);
    autoGreetAction(data.autoGreetType || "");
    autoChatAction(data.autoChatType || "");
    autoGreetLevelAction(data.autoGreetLevel || "");
    if (data.customer) {
      if (data.condition) {
        setStateTag(9);
        setCondition(data.condition);
      } else {
        setStateTag(10);
      }
      setCurrentPositionName(data.currentPosition || "");
      setNextPositionName(data.nextPosition || "");
      data.bot && setBossName(data.bot.name);
    } else {
    }
  }

  function checkFilterPanel(data: any) {
    console.log("home checkFilterPanel", data);
    autoGreetAction(data.autoGreetType || "");
    autoChatAction(data.autoChatType || "");
    autoGreetLevelAction(data.autoGreetLevel || "");
    setBossDataSource(data.filter);
    setRecommendList([]);
  }

  function addRecommendList(data: any) {
    console.log("home addRecommendList", data);
    autoGreetAction(data.autoGreetType || "");
    autoChatAction(data.autoChatType || "");
    autoGreetLevelAction(data.autoGreetLevel || "");
    var list = data && data.isrefresh === true ? [] : [...recommendList];
    var shouldUpdateList = false;
    if (data && data.list) {
      for (const item of data.list) {
        let idx = list.findIndex(
          (ele) => ele.uuid === item.uuid && ele.name === item.name
        );
        if (idx === -1) {
          list.push(item);
          shouldUpdateList = true;
        }
      }
    }

    // let list = recommendList.concat(data.list);
    if (shouldUpdateList) {
      setStateTag(11);
      setRecommendList(list);
    }
    setCurrentPositionName(data.currentPosition || "");
  }

  function replySwitchPast(data: any) {
    console.log("home replySwitchPast ", data);
    if (data.switchPaste === true || data.switchPaste === false) {
      setSwitchPast(data.switchPaste);
    }
  }

  function autoGreetLevelAction(data: any) {
    console.log("home autoGreetLevelAction L2 或者 L3 模式", data);
    let isL3 = data && data.includes("L3");
    let isL2 = data && data.includes("L2");
    localStorage.setItem("autoGreetType", data);
    if (isL2 || isL3) {
      setMode(isL3 ? "L3" : "L2");
    }
  }

  function autoChatLevelAction(data: any) {
    console.log("home autoChatLevelAction L2 或者 L3 模式", data);
    let isL3 = data && data.includes("L3");
    let isL2 = data && data.includes("L2");
    localStorage.setItem("autoChatType", data);
    if (isL2 || isL3) {
      setMode(isL3 ? "L3" : "L2");
    }
  }

  function autoGreetAction(data: any) {
    console.log("home autoGreetAction 是否自动打招呼", data);
    localStorage.setItem("autoGreetType", data);
    setSwitchAuto(data === "mx_board_auto_greet_open");
  }

  function autoChatAction(data: any) {
    console.log("home autoChatAction 是否自动聊天", data);
    localStorage.setItem("autoChatType", data);
    setSwitchAutoChat(data === "mx_board_auto_chat_open");
  }
  function updateCandidateUser(data: any) {
    console.log(
      "home updateCandidateUser 更新候选人打招呼状态",
      data,
      recommendList
    );
    autoGreetAction(data.autoGreetType || "");
    autoChatAction(data.autoChatType || "");
    var list = [...recommendList];
    let idx = list.findIndex(
      (ele) => ele.uuid === data.uuid && ele.name === data.name
    );
    if (idx !== -1) {
      list[idx].type = data.type;
    }
    setRecommendList(list);
  }

  return (
    <div className="container" style={{ margin: 0 }}>
      {[-1, 0, 1, 2, 3, 4, 5, 6].includes(stateTag) && (
        <div className="part">
          <UserBossComponent userName={userName} bossName={bossName} />
          {chatList.length > 0 && (
            <div className="chat-list">
              {chatList.map((message, index) => (
                <div key={index} className="chat-item">
                  {message.flow === 1 && <span>{message.bot.name}：</span>}
                  {message.flow === 2 && <span>{message.customer.name}：</span>}
                  {message.flow === 3 && <span>系统消息：</span>}
                  <div className="content">{message.txt}</div>
                </div>
              ))}
            </div>
          )}
          {stateTag === -1 && (
            <LampComponent lampClass="red" text={TEXTS.socketError} />
          )}
          {stateTag === 0 && (
            <LampComponent lampClass="yellow" text={TEXTS.clickCandidate} />
          )}
          {stateTag === 1 && (
            <LampComponent lampClass="yellow" text={TEXTS.waitReply} />
          )}
          {stateTag === 2 && (
            <div>
              <LampComponent
                lampClass="blue"
                text={TEXTS.clickOnlineResumeAndScroll}
              >
                <img
                  src={introduceOneImage}
                  alt=""
                  className="introduce-1-img"
                  style={LAMP_STYLES}
                />
              </LampComponent>
              <LampComponent lampClass="blue" text={TEXTS.closeOnlineResume} />
              <LampComponent lampClass="yellow" text={TEXTS.waitReply} />
            </div>
          )}

          {stateTag === 3 && (
            <>
              {replyList.length > 0 && (
                <div>
                  {replyList.map((message, index) => (
                    <div key={index}>
                      {message.type === "text" && (
                        <LampComponent
                          lampClass={`${copySendOk ? "green" : "yellow"}`}
                          text={TEXTS.pleaseReply}
                        >
                          <div className="reply-content">{`${message.content}`}</div>
                          <div
                            style={{
                              display: "flex",
                              marginTop: 10,
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div className="copy-text">
                              {TEXTS.copiedToClipboard}
                            </div>
                            <UpdateDialogButton
                              bot={{ uid: botInfo.uid }}
                              customer={{ uid: customerInfo.uid }}
                              content={message.content || ""}
                              action="update_dialog"
                              title="我已发"
                            ></UpdateDialogButton>
                          </div>
                        </LampComponent>
                      )}

                      {message.type === "accept_resume" && (
                        <LampComponent
                          lampClass="blue"
                          text={TEXTS.clickAgreeAcceptResume}
                        >
                          <img
                            src={introduceNineImage}
                            alt=""
                            className="introduce-2-img"
                            style={LAMP_STYLES}
                          />
                          <div
                            style={{
                              display: "flex",
                              marginTop: 10,
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <UpdateDialogButton
                              bot={{ uid: botInfo.uid }}
                              customer={{ uid: customerInfo.uid }}
                              content=""
                              action="update_dialog"
                              title="我已同意接收简历"
                            ></UpdateDialogButton>
                          </div>
                        </LampComponent>
                      )}

                      {message.type === "accept_wechat" && (
                        <LampComponent
                          lampClass="blue"
                          text={TEXTS.clickAgreeExchangeWechat}
                        >
                          <img
                            src={introduceEightImage}
                            alt=""
                            className="introduce-2-img"
                            style={LAMP_STYLES}
                          />
                          <div
                            style={{
                              display: "flex",
                              marginTop: 10,
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <UpdateDialogButton
                              bot={{ uid: botInfo.uid }}
                              customer={{ uid: customerInfo.uid }}
                              content=""
                              action="accept_wechat"
                              title="我已同意交换微信"
                            ></UpdateDialogButton>
                          </div>
                        </LampComponent>
                      )}

                      {/* {message.type === "accept_phone" && (
                        <LampComponent
                          lampClass="blue"
                          text={TEXTS.clickAgreeExchangeWechat}
                        >
                          <img
                            src={introduceTwoImage}
                            alt=""
                            className="introduce-2-img"
                            style={LAMP_STYLES}
                          />
                          <div
                            style={{
                              display: "flex",
                              marginTop: 10,
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div style={LAMP_STYLES} className="finish-text">
                              {TEXTS.nextCandidate}
                            </div>
                            <UpdateDialogButton
                              bot={{ uid: botInfo.uid }}
                              customer={{ uid: customerInfo.uid }}
                              content=""
                              action="accept_phone"
                              title="我已同意交换手机号"
                            ></UpdateDialogButton>
                          </div>
                        </LampComponent>
                      )} */}

                      {message.type === "request_wechat" && (
                        <LampComponent
                          lampClass="blue"
                          text={TEXTS.clickWechat}
                        >
                          <img
                            src={introduceTenImage}
                            alt=""
                            className="introduce-2-img"
                            style={LAMP_STYLES}
                          />
                          <div
                            style={{
                              display: "flex",
                              marginTop: 10,
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div style={LAMP_STYLES} className="finish-text">
                              {TEXTS.nextCandidate}
                            </div>
                            <UpdateDialogButton
                              bot={{ uid: botInfo.uid }}
                              customer={{ uid: customerInfo.uid }}
                              content=""
                              action="request_wechat"
                              title="我已请求微信"
                            ></UpdateDialogButton>
                          </div>
                        </LampComponent>
                      )}
                      {message.type === "request_phone" && (
                        <LampComponent lampClass="blue" text={TEXTS.clickPhone}>
                          <img
                            src={introduceElevenImage}
                            alt=""
                            className="introduce-2-img"
                            style={LAMP_STYLES}
                          />
                          <div
                            style={{
                              display: "flex",
                              marginTop: 10,
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div style={LAMP_STYLES} className="finish-text">
                              {TEXTS.nextCandidate}
                            </div>
                            <UpdateDialogButton
                              bot={{ uid: botInfo.uid }}
                              customer={{ uid: customerInfo.uid }}
                              content=""
                              action="request_phone"
                              title="我已请求电话"
                            ></UpdateDialogButton>
                          </div>
                        </LampComponent>
                      )}
                      {message.type === "request_resume" && (
                        <LampComponent
                          lampClass="blue"
                          text={TEXTS.clickOnlineResume}
                        >
                          <img
                            src={introduceTwoImage}
                            alt=""
                            className="introduce-2-img"
                            style={LAMP_STYLES}
                          />
                          <div
                            style={{
                              display: "flex",
                              marginTop: 10,
                              justifyContent: "space-between",
                              alignItems: "center",
                            }}
                          >
                            <div style={LAMP_STYLES} className="finish-text">
                              {TEXTS.nextCandidate}
                            </div>
                            <UpdateDialogButton
                              bot={{ uid: botInfo.uid }}
                              customer={{ uid: customerInfo.uid }}
                              content=""
                              action="request_resume"
                              title="我已请求简历"
                            ></UpdateDialogButton>
                          </div>
                          {/* <div style={LAMP_STYLES} className="finish-text">
                            {TEXTS.nextCandidate}
                          </div> */}
                        </LampComponent>
                      )}
                    </div>
                  ))}
                </div>
              )}
            </>
          )}

          {[4, 5].includes(stateTag) && (
            <div>
              <LampComponent lampClass="blue" text={TEXTS.downloadAttachment}>
                {stateTag === 4 && (
                  <img
                    src={introduceThreeImage}
                    alt=""
                    className="introduce-3-img"
                    style={LAMP_STYLES}
                  />
                )}
                <img
                  src={introduceFourImage}
                  alt=""
                  className="introduce-4-img"
                  style={LAMP_STYLES}
                />
                <img
                  src={introduceFiveImage}
                  alt=""
                  className="introduce-5-img"
                  style={LAMP_STYLES}
                />
              </LampComponent>

              <LampComponent lampClass="blue" text={TEXTS.closeAttachment} />

              {replyContent && (
                <LampComponent
                  lampClass="green-passed"
                  text={TEXTS.pleaseReply}
                >
                  <div className="reply-content">{`${replyContent}`}</div>
                  <div className="copy-text">{TEXTS.copiedToClipboard}</div>
                  <div style={{ marginTop: "10px" }} className="finish-text">
                    {TEXTS.nextCandidate}
                  </div>
                </LampComponent>
              )}
            </div>
          )}
          {stateTag === 6 && (
            <LampComponent
              lampClass="gray"
              text={TEXTS.noReplyToNextCandidate}
            />
          )}
        </div>
      )}
      {[7].includes(stateTag) && (
        <div className="part">
          <UserBossComponent userName={userName} bossName={bossName} />
          <LampComponent
            lampClass="blue"
            text={TEXTS.switchToPositionManagement}
          />
        </div>
      )}
      {[12].includes(stateTag) && (
        <div className="part">
          <UserBossComponent userName={userName} bossName={bossName} />
          <LampComponent lampClass="blue" text={TEXTS.getQuota}>
            <img
              src={introduceSevenImage}
              alt=""
              className="introduce-1-img"
              style={LAMP_STYLES}
            />
          </LampComponent>
        </div>
      )}
      {[8].includes(stateTag) && (
        <div className="part">
          <UserBossComponent userName={userName} bossName={bossName} />
          <LampComponent lampClass="blue" text={TEXTS.switchToRecommend} />
        </div>
      )}
      {[9].includes(stateTag) && (
        <div className="part">
          <UserBossComponent
            userName={currentPositionName}
            bossName={bossName}
          />

          <LampComponent lampClass="blue" text={TEXTS.setBossRecommend}>
            <FilterPanel
              condition={condition}
              filter={bossDataSource}
            ></FilterPanel>
          </LampComponent>
        </div>
      )}
      {[10].includes(stateTag) && (
        <div className="part">
          <UserBossComponent
            userName={currentPositionName}
            bossName={bossName}
          />

          <div className="lamp-image">
            <div className="color-lamp" style={{ paddingBottom: "10px" }}>
              <div className="lamp blue"></div>
              <span>{TEXTS.changePositionName}</span>
            </div>
            <span>{nextPositionName}</span>
          </div>
        </div>
      )}
      {[11, 13].includes(stateTag) && (
        <div className="part">
          <UserBossComponent
            userName={currentPositionName}
            bossName={bossName}
          />
          {stateTag === 13 && (
            <div className="lamp-image">
              <div className="color-lamp">
                <div className="lamp red"></div>
                <span style={{ color: "red" }}>{TEXTS.noQuota}</span>
              </div>
            </div>
          )}
          {bossDataSource === false && (
            <LampComponent lampClass="blue" text={TEXTS.setBossRecommend}>
              <FilterPanel
                condition={condition}
                filter={bossDataSource}
              ></FilterPanel>
            </LampComponent>
          )}
          {recommendList.length > 0 && (
            <div className="recommend-list">
              {recommendList.map((user: UserType, index) => (
                <div key={index}>
                  <div className="color-lamp" style={{ paddingBottom: "10px" }}>
                    <div className={`lamp ${stypeObj[user.type]}`}></div>
                    <div>{user.name}</div>
                    <div style={{ padding: "0 10px" }}>{user.uuid}</div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      <Button
        variant="primary"
        style={{ position: "fixed", left: "10px", bottom: "10px" }}
        onClick={() => {
          window.location.reload();
        }}
      >
        <FontAwesomeIcon icon={faSyncAlt} />
      </Button>
      <Button
        variant="primary"
        style={{ position: "fixed", left: "10px", bottom: "60px" }}
        onClick={() => {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
        }}
      >
        <FontAwesomeIcon icon={faArrowUp} size="lg" />
      </Button>
      {/* className={switchAuto ? "" : ""} */}
      {/* variant={mode === "L3" ? "outline-primary" : "outline-warning"} */}
      <Button
        style={{
          position: "fixed",
          right: "10px",
          bottom: "210px",
          backgroundColor: mode === "L3" ? "#00bebd" : "#0d6efd",
          color: "white",
          border: "none",
        }}
        disabled={switchAuto}
        onClick={() => {
          setMode(mode === "L3" ? "L2" : "L3");
          socketClient.sendMessage({
            customer: { uid: customerInfo.uid },
            bot: { uid: botInfo.uid },
            action: `mx_board_auto_${mode === "L3" ? "L2" : "L3"}_mode`,
            platform: "boss",
            dialogList: [],
            special: 1,
            message_list: [],
            isFromBoss: 0,
          });
        }}
      >
        {mode === "L3" ? "Switch to L2 Mode" : "Switch to L3 Mode"}
      </Button>
      <Button
        variant={switchAuto ? "outline-danger" : "outline-primary"}
        style={{ position: "fixed", right: "10px", bottom: "160px" }}
        onClick={() => {
          socketClient.sendMessage({
            customer: { uid: customerInfo.uid },
            bot: { uid: botInfo.uid },
            action: switchAuto
              ? "mx_board_auto_greet_close"
              : "mx_board_auto_greet_open",
            platform: "boss",
            dialogList: [],
            special: 1,
            message_list: [],
            isFromBoss: 0,
          });
          setSwitchAuto(!switchAuto);
        }}
      >
        {switchAuto ? "关闭自动打招呼" : "开启自动打招呼"}
      </Button>
      <Button
        variant={switchAutoChat ? "outline-danger" : "outline-primary"}
        style={{ position: "fixed", right: "10px", bottom: "110px" }}
        onClick={() => {
          socketClient.sendMessage({
            customer: { uid: customerInfo.uid },
            bot: { uid: botInfo.uid },
            action: switchAutoChat
              ? "mx_board_auto_chat_close"
              : "mx_board_auto_chat_open",
            platform: "boss",
            dialogList: [],
            special: 1,
            message_list: [],
            isFromBoss: 0,
          });
          setSwitchAutoChat(!switchAutoChat);
        }}
      >
        {switchAutoChat ? "关闭自动聊天" : "开启自动聊天"}
      </Button>
      <Button
        variant={switchPast ? "outline-danger" : "outline-primary"}
        style={{ position: "fixed", right: "10px", bottom: "60px" }}
        onClick={() => {
          socketClient.sendMessage({
            customer: { uid: customerInfo.uid },
            bot: { uid: botInfo.uid },
            action: "mx_board_paste",
            platform: "boss",
            dialogList: [],
            special: 1,
            message_list: [],
            isFromBoss: 0,
          });
          setSwitchPast(!switchPast);
        }}
      >
        {switchPast ? "关闭粘贴" : "开启粘贴"}
      </Button>
      <Button
        variant="outline-danger"
        style={{ position: "fixed", right: "10px", bottom: "10px" }}
        onClick={() => {
          localStorage.removeItem("name");
          localStorage.removeItem("room");
          socketClient.disconnect();
          setTimeout(() => {
            navigate("/login");
          }, 500);
        }}
      >
        退出账号
      </Button>
    </div>
  );
}

export default HomePage;
